import { ROUTES } from "../constants";
import { UserRole } from "../constants";

/**
 * Returns the home route to navigate to after successful login,
 * based on the user's role.
 */
export function getPostLoginRoute(roleId: number | null | undefined): string {
  if (roleId === UserRole.SuperAdmin) {
    return ROUTES.TENANT_MANAGEMENT;
  }
  return ROUTES.DASHBOARD;
}
